<div class="flex flex-col items-center justify-center min-h-screen bg-gray-50 p-6">
  <div class="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
    <div class="mb-6">
      <svg class="mx-auto h-24 w-24 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
      </svg>
    </div>
    <h1 class="text-2xl font-bold text-gray-800 mb-4">{{ 'noPermission.title' | transloco }}</h1>
    <p class="text-gray-600 mb-6">
      {{ 'noPermission.message' | transloco }}
    </p>
    <p class="text-sm text-gray-500 mb-8">
      {{ 'noPermission.contactAdmin' | transloco }}
    </p>
    <button
      (click)="logout()"
      class="w-full bg-blue-600 text-white py-3 px-6 rounded-md hover:bg-blue-700 transition-colors font-medium">
      {{ 'noPermission.logoutAndLogin' | transloco }}
    </button>
  </div>
</div>
